<template>
  <div id="app">
    <GlobalHeader />
    <div class="main-content">
      <router-view />
    </div>
    <dibu />

    <!-- 回到顶部 -->
    <button
      class="back-to-top"
      :class="{ visible: showTop }"
      @click="scrollToTop"
      aria-label="回到顶部"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"/>
      </svg>
    </button>

    <!-- 下载弹窗 -->
    <transition name="dl-pop">
      <div v-if="showDl" class="dl-overlay" @click="showDl = false">
        <div class="dl-popup" :style="dlStyle" @click.stop>
          <img
            src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/iosxiazai.png"
            alt="下载 App"
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GlobalHeader from './components/GlobalHeader.vue'
import dibu from './components/dibu.vue'
export default {
  name: 'App',
  components: { GlobalHeader, dibu },
  data() {
    return {
      showTop: false,
      showDl: false,
      dlStyle: {}
    }
  },
  methods: {
    handleScroll() {
      this.showTop = window.scrollY > 400
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onDownloadClick(e) {
      let el = e.target
      while (el && el !== document) {
        if (el.nodeType === 1 && el.getAttribute && el.getAttribute('href') === '#download') {
          e.preventDefault()
          e.stopPropagation()
          if (this.showDl) {
            this.showDl = false
            return
          }
          const r = el.getBoundingClientRect()
          this.dlStyle = { left: r.left + 'px', top: (r.bottom + 6) + 'px', width: r.width + 'px' }
          this.$nextTick(() => { this.showDl = true })
          return
        }
        el = el.parentNode
      }
      if (this.showDl && !e.target.closest('.dl-popup')) this.showDl = false
    }
  },
  mounted() {
    console.log(this.$route.fullPath)
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.onDownloadClick)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.onDownloadClick)
  }
}
</script>

<style>
#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #26333d;
  margin: 0;
}
*{
  margin: 0;
  box-sizing: border-box;
}
body {
  margin: 0;
  overflow-x: hidden;
  background: #fff;
}

img {
  max-width: 100%;
}

.gc-page {
  width: 100%;
  overflow: hidden;
  background: #fff;
}

.gc-hero {
  position: relative;
  min-height: 560px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 86px 24px;
  color: #fff;
  background-position: center;
  background-size: cover;
  text-align: center;
}

.gc-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(20, 127, 153, 0.72);
}

.gc-hero.home-hero::before {
  background: rgba(27, 38, 39, 0.35);
}

.gc-hero-content {
  position: relative;
  z-index: 1;
  max-width: 920px;
}

.gc-hero h1 {
  font-size: clamp(56px, 9vw, 116px);
  line-height: 0.94;
  letter-spacing: 0;
  font-weight: 900;
  text-shadow: 4px 5px 0 rgba(0, 0, 0, 0.24);
  overflow-wrap: anywhere;
}

.gc-hero p {
  max-width: 780px;
  margin: 32px auto 0;
  font-size: clamp(22px, 3vw, 36px);
  line-height: 1.12;
  font-weight: 900;
  text-shadow: 3px 4px 0 rgba(0, 0, 0, 0.22);
}

.gc-section {
  padding: 120px 24px;
}

.gc-section.light-blue {
  background: #bce6f7;
}

.gc-section.deep-blue {
  background: #1765b2;
  color: #fff;
}

.gc-container {
  width: min(1120px, 100%);
  margin: 0 auto;
}

.gc-eyebrow {
  color: #a96526;
  font-weight: 900;
  font-size: 18px;
  margin-bottom: 14px;
}

.gc-title {
  color: #1765b2;
  font-size: clamp(38px, 5vw, 64px);
  line-height: 1.02;
  font-weight: 900;
  margin-bottom: 22px;
}

.gc-copy {
  color: #68717b;
  font-size: 20px;
  line-height: 1.65;
}

.gc-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  padding: 0 30px;
  border-radius: 8px;
  border: 0;
  background: #1765b2;
  color: #fff;
  font-weight: 900;
  font-size: 17px;
  text-decoration: none;
}

.gc-grid {
  display: grid;
  gap: 24px;
}

.gc-card {
  background: #fff;
  border-radius: 6px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(18, 47, 62, 0.12);
}

@media (max-width: 780px) {
  .gc-hero {
    min-height: 520px;
    padding: 58px 28px;
  }

  .gc-hero h1 {
    font-size: clamp(48px, 15vw, 72px);
    line-height: 1.02;
  }

  .gc-section {
    padding: 80px 28px;
  }

  .gc-copy {
    font-size: 18px;
  }

  .back-to-top {
    width: 44px;
    height: 44px;
    right: 16px;
    bottom: 16px;
  }

  .back-to-top svg {
    width: 22px;
    height: 22px;
  }
}

/* 回到顶部 */
.back-to-top {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 999;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 0;
  background: #1B5BA6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(27, 91, 166, 0.35);
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
  transition: opacity 0.3s, transform 0.3s;
}

.back-to-top.visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.back-to-top:hover {
  background: #174a8a;
}

.back-to-top svg {
  width: 26px;
  height: 26px;
}

/* 下载弹窗 */
.dl-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.dl-popup {
  position: absolute;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
  background: #fff;
  transform-origin: top center;
}

.dl-popup img {
  width: 100%;
  display: block;
}

.dl-pop-enter-active,
.dl-pop-leave-active {
  transition: opacity 0.2s;
}

.dl-pop-enter-active .dl-popup,
.dl-pop-leave-active .dl-popup {
  transition: transform 0.25s ease, opacity 0.2s;
}

.dl-pop-enter,
.dl-pop-leave-to {
  opacity: 0;
}

.dl-pop-enter .dl-popup,
.dl-pop-leave-to .dl-popup {
  transform: translateY(-12px) scale(0.97);
  opacity: 0;
}
</style>
